import FocuSwiftImg from '@assets/projects/FocuSwift.png'
import UCGatorImg from '@assets/projects/UCGator.jpg'
import MoniImg from '@assets/projects/Moni.png'
import DonezoImg from '@assets/projects/Donezo.png'

export const projects = [
  {
    id: 1,
    title: 'FocuSwift',
    description: 'A pomodoro timer app with automatic breaks for productivity efficiency built with C#.',
    tags: ['C#'],
    image: FocuSwiftImg,
    link: 'https://github.com/MarcKyle/FocuSwift'
  },
  {
    id: 2,
    title: 'UCGator',
    description: 'An Augmented-reality navigational assistance app for the University of Cebu Lapu-Lapu and Mandaue Campus built with React-native and Expo',
    tags: ['React Native', 'Expo', 'Firebase'],
    image: UCGatorImg,
    link: 'https://github.com/ShiraZone/UCGATOR_USER'
  },
  {
    id: 3,
    title: 'Moni',
    description: 'A Personal finance and savings tracker for financial awareness built with DJango.',
    tags: ['Python', 'SQLite', 'DJango'],
    image: MoniImg,
    link: 'https://github.com/MarcKyle/moni-project'
  },
  {
    id: 4,
    title: 'Donezo',
    description: 'A user-friendly web application designed to help users manage their tasks and stay organized.',
    tags: ['Tailwind CSS', 'Django'],
    image: DonezoImg,
    link: 'https://github.com/shirakizuki/fujidonezo'
  },
]
